/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createAdoInstanceRequestSchema = z.object({
  accountId: z.string().min(1),
  oauthCredentialsId: z.int(),
});
